/* tslint:disable */
/* eslint-disable */
/* @relayHash 55b5ea024c93e387335a131f5c32cb62 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsFooterQueryVariables = {
    isArt: boolean;
    itemId: string;
    count?: number | null;
    cursor?: string | null;
    isTrade: boolean;
};
export type PdpRespSimilarItemsFooterQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_viewer">;
    };
};
export type PdpRespSimilarItemsFooterQuery = {
    readonly response: PdpRespSimilarItemsFooterQueryResponse;
    readonly variables: PdpRespSimilarItemsFooterQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isArt",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "itemId",
    "variableName": "itemId"
  },
  {
    "kind": "Literal",
    "name": "seller",
    "value": "EXCLUDE"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryPath",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "browseUrl",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ecommerceTrackingParams",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isFurniture",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "localizedPdpUrl",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "classification",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemClassification",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "creationDate",
      "args": null,
      "storageKey": null
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "creators",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemCreator",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "attribution",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creator",
      "storageKey": null,
      "args": null,
      "concreteType": "Creator",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        (v12/*: any*/)
      ]
    },
    (v12/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isArt",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isLinkable",
      "args": null,
      "storageKey": null
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vertical",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "shipmentQuotes",
  "storageKey": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isComplimentary",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "totalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        (v17/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "region",
          "storageKey": null,
          "args": null,
          "concreteType": "Region",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "regionName",
              "args": null,
              "storageKey": null
            },
            (v12/*: any*/)
          ]
        },
        (v12/*: any*/)
      ]
    },
    (v12/*: any*/)
  ]
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isStorefrontOnly",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isMultiSku",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "variableAttributes",
  "storageKey": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "variableAttributeData",
      "storageKey": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "swatchSort",
          "storageKey": null,
          "args": null,
          "concreteType": "SwatchSort",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "swatch",
              "storageKey": null,
              "args": null,
              "concreteType": "Swatch",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v11/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                },
                (v12/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    (v12/*: any*/)
  ]
},
v22 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "displayPrice",
  "storageKey": null,
  "args": [
    {
      "kind": "Variable",
      "name": "isTrade",
      "variableName": "isTrade"
    },
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    }
  ],
  "concreteType": "ItemDisplayPriceType",
  "plural": true,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "convertedAmountList",
      "storageKey": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "plural": true,
      "selections": [
        (v17/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantityDisplay",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "percentageOff",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "textType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "amountType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceLabel",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "showPriceVariability",
      "args": null,
      "storageKey": null
    }
  ]
},
v23 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quickViewDisplay",
  "storageKey": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "alias": "mobileTitle",
      "name": "title",
      "args": (v23/*: any*/),
      "storageKey": "title(formatType:\"MOBILE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphs",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "key",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "text",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": "mobileText",
          "name": "text",
          "args": (v23/*: any*/),
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "paragraphAttributeNames",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "period",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "origin",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "style",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "periodPrefix",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creators",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v15/*: any*/)
      ]
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "measurement",
  "storageKey": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "display",
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")",
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "unit",
          "args": null,
          "storageKey": null
        },
        (v25/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "size",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSize",
      "plural": false,
      "selections": [
        (v25/*: any*/)
      ]
    }
  ]
},
v27 = {
  "kind": "LinkedField",
  "alias": "productPhotos",
  "name": "photos",
  "storageKey": "photos(limit:1)",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "placeholder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "masterOrZoomPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "versions",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "webPath",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v12/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsFooterQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItemsFooter_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              {
                "kind": "Variable",
                "name": "isArt",
                "variableName": "isArt"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpRespSimilarItemsFooterQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "similarItems",
            "name": "moreLikeThisItem",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "moreLikeThisItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Item",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": "similarItems",
            "name": "moreLikeThisItem",
            "args": (v1/*: any*/),
            "handle": "connection",
            "key": "PdpRespSimilarItemsFooter_similarItems",
            "filters": [
              "seller",
              "itemId"
            ]
          },
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          (v12/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isArt",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "visuallySimilarGridItems",
                "name": "visualSearch",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 6
                  },
                  {
                    "kind": "Variable",
                    "name": "itemPk",
                    "variableName": "itemId"
                  }
                ],
                "concreteType": "VisualSearchConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VisualSearchEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v24/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v12/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PdpRespSimilarItemsFooterQuery",
    "id": "app-buyer-finding/292.0.0-2020-11-20T23:59:39.967Z/PdpRespSimilarItemsFooterQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '57de5fde9c140c96bf8c58a11a4b990e';
export default node;
